"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processNamespace = exports.prepareAST = exports.process = exports.createEmptyMeta = exports.validateScopingSelector = exports.StylableProcessor = exports.processorWarnings = void 0;
const postcss = __importStar(require("postcss"));
const diagnostics_1 = require("./diagnostics");
const deprecated_selector_utils_1 = require("./deprecated/deprecated-selector-utils");
const native_reserved_lists_1 = require("./native-reserved-lists");
const stylable_meta_1 = require("./stylable-meta");
const features_1 = require("./features");
const diagnostics_2 = require("./features/diagnostics");
const features_2 = require("./features");
const stylable_utils_1 = require("./stylable-utils");
const process_declaration_functions_1 = require("./process-declaration-functions");
const selector_1 = require("./helpers/selector");
const rule_1 = require("./helpers/rule");
const value_mapping_1 = require("./deprecated/value-mapping");
const stylable_value_parsers_1 = require("./stylable-value-parsers");
const deprecation_1 = require("./helpers/deprecation");
const parseStates = stylable_value_parsers_1.SBTypesParsers[`-st-states`];
const parseGlobal = stylable_value_parsers_1.SBTypesParsers[`-st-global`];
const parseExtends = stylable_value_parsers_1.SBTypesParsers[`-st-extends`];
exports.processorWarnings = {
    STATE_DEFINITION_IN_ELEMENT() {
        return 'cannot define pseudo states inside a type selector';
    },
    STATE_DEFINITION_IN_COMPLEX() {
        return 'cannot define pseudo states inside complex selectors';
    },
    CANNOT_RESOLVE_EXTEND(name) {
        return `cannot resolve '-st-extends' type for '${name}'`;
    },
    CANNOT_EXTEND_IN_COMPLEX() {
        return `cannot define "-st-extends" inside a complex selector`;
    },
    OVERRIDE_TYPED_RULE(key, name) {
        return `override "${key}" on typed rule "${name}"`;
    },
    INVALID_NESTING(child, parent) {
        return `nesting of rules within rules is not supported, found: "${child}" inside "${parent}"`;
    },
};
class StylableProcessor {
    constructor(diagnostics = new diagnostics_1.Diagnostics(), resolveNamespace = features_2.STNamespace.defaultProcessNamespace) {
        this.diagnostics = diagnostics;
        this.resolveNamespace = resolveNamespace;
        this.customSelectorData = {};
    }
    process(root) {
        this.meta = new stylable_meta_1.StylableMeta(root, this.diagnostics);
        features_2.STImport.hooks.analyzeInit(this);
        features_1.CSSCustomProperty.hooks.analyzeInit(this);
        this.handleAtRules(root);
        root.walkRules((rule) => {
            if (!(0, rule_1.isChildOfAtRule)(rule, 'keyframes')) {
                this.handleRule(rule, {
                    isScoped: (0, rule_1.isChildOfAtRule)(rule, `st-scope`),
                    reportUnscoped: true,
                });
            }
            const parent = rule.parent;
            if ((parent === null || parent === void 0 ? void 0 : parent.type) === 'rule') {
                this.diagnostics.error(rule, exports.processorWarnings.INVALID_NESTING(rule.selector, parent.selector));
            }
        });
        root.walkDecls((decl) => {
            const parent = decl.parent;
            if (parent.type === 'rule' && parent.selector === ':vars') {
                // ToDo: remove once
                // - custom property definition is allowed in var value
                // - url collection is removed from st-var
                return;
            }
            // ToDo: refactor to be hooked by features
            if (value_mapping_1.stValuesMap[decl.prop] && parent.type === 'rule') {
                this.handleDirectives(parent, decl);
            }
            features_1.CSSCustomProperty.hooks.analyzeDeclaration({ context: this, decl });
            this.collectUrls(decl);
        });
        features_2.STNamespace.setMetaNamespace(this, this.resolveNamespace);
        features_2.STSymbol.reportRedeclare(this);
        prepareAST(this.meta, root);
        return this.meta;
    }
    handleAtRules(root) {
        const analyzeRule = (rule, { isScoped }) => {
            return this.handleRule(rule, {
                isScoped,
                reportUnscoped: false,
            });
        };
        root.walkAtRules((atRule) => {
            switch (atRule.name) {
                case 'st-import': {
                    features_2.STImport.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                }
                case 'namespace':
                case 'st-namespace': {
                    features_2.STNamespace.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                }
                case 'keyframes':
                    features_2.CSSKeyframes.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                case 'layer':
                    features_2.CSSLayer.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                case 'import':
                    features_2.CSSLayer.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                case 'custom-selector': {
                    const params = atRule.params.split(/\s/);
                    const customName = params.shift();
                    if (customName && customName.match(stylable_utils_1.CUSTOM_SELECTOR_RE)) {
                        const selector = atRule.params.replace(customName, '').trim();
                        const isScoped = analyzeRule(postcss.rule({ selector, source: atRule.source }), { isScoped: false });
                        this.customSelectorData[customName] = {
                            isScoped,
                        };
                        this.meta.customSelectors[customName] = selector;
                    }
                    else {
                        // TODO: add warn there are two types one is not valid name and the other is empty name.
                    }
                    break;
                }
                case 'st-scope':
                    features_2.STScope.hooks.analyzeAtRule({ context: this, atRule, analyzeRule });
                    break;
                case 'property':
                case 'st-global-custom-property': {
                    features_1.CSSCustomProperty.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                        analyzeRule,
                    });
                    break;
                }
            }
        });
    }
    collectUrls(decl) {
        (0, process_declaration_functions_1.processDeclarationFunctions)(decl, (node) => {
            if (node.type === 'url') {
                this.meta.urls.push(node.url);
            }
        }, false);
    }
    handleRule(rule, { isScoped, reportUnscoped }) {
        rule.selectorAst = (0, deprecated_selector_utils_1.parseSelector)(rule.selector);
        const selectorAst = (0, selector_1.parseSelectorWithCache)(rule.selector);
        let locallyScoped = isScoped;
        let simpleSelector;
        (0, selector_1.walkSelector)(selectorAst, (node, ...nodeContext) => {
            var _a;
            const [index, nodes, parents] = nodeContext;
            const type = node.type;
            if (type === 'selector' && !(0, selector_1.isInPseudoClassContext)(parents)) {
                // reset scope check between top level selectors
                locallyScoped = isScoped;
            }
            if (type !== `selector` && type !== `class` && type !== `type`) {
                simpleSelector = false;
            }
            if (node.type === 'pseudo_class') {
                if (node.value === 'import') {
                    features_2.STImport.hooks.analyzeSelectorNode({
                        context: this,
                        node,
                        rule,
                        walkContext: nodeContext,
                    });
                }
                else if (node.value === 'vars') {
                    return features_1.STVar.hooks.analyzeSelectorNode({
                        context: this,
                        node,
                        rule,
                        walkContext: nodeContext,
                    });
                }
                else if (node.value === `global`) {
                    return features_2.STGlobal.hooks.analyzeSelectorNode({
                        context: this,
                        node,
                        rule,
                        walkContext: nodeContext,
                    });
                }
                else if (node.value.startsWith('--')) {
                    locallyScoped =
                        locallyScoped ||
                            ((_a = this.customSelectorData[`:${node.value}`]) === null || _a === void 0 ? void 0 : _a.isScoped) ||
                            false;
                }
                else if (!native_reserved_lists_1.knownPseudoClassesWithNestedSelectors.includes(node.value)) {
                    return selector_1.walkSelector.skipNested;
                }
            }
            else if (node.type === 'class') {
                features_2.CSSClass.hooks.analyzeSelectorNode({
                    context: this,
                    node,
                    rule,
                    walkContext: nodeContext,
                });
                locallyScoped = features_2.CSSClass.validateClassScoping({
                    context: this,
                    classSymbol: features_2.CSSClass.get(this.meta, node.value),
                    locallyScoped,
                    reportUnscoped,
                    node,
                    nodes,
                    index,
                    rule,
                });
            }
            else if (node.type === 'type') {
                features_2.CSSType.hooks.analyzeSelectorNode({
                    context: this,
                    node,
                    rule,
                    walkContext: nodeContext,
                });
                locallyScoped = features_2.CSSType.validateTypeScoping({
                    context: this,
                    locallyScoped,
                    reportUnscoped,
                    node,
                    nodes,
                    index,
                    rule,
                });
            }
            else if (node.type === `id`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(`#` + node.value, `id`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            else if (node.type === `attribute`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(`[${node.value}]`, `attribute`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            else if (node.type === `nesting`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(node.value, `nesting`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            return;
        });
        if (simpleSelector !== false) {
            rule.isSimpleSelector = true;
            rule.selectorType = rule.selector.match(/^\./) ? 'class' : 'element';
        }
        else {
            rule.selectorType = 'complex';
        }
        return locallyScoped;
    }
    handleDirectives(rule, decl) {
        const isSimplePerSelector = (0, selector_1.isSimpleSelector)(rule.selector);
        const type = isSimplePerSelector.reduce((accType, { type }) => {
            return !accType ? type : accType !== type ? `complex` : type;
        }, ``);
        const isSimple = type !== `complex`;
        if (decl.prop === `-st-states`) {
            if (isSimple && type !== 'type') {
                this.extendTypedRule(decl, rule.selector, `-st-states`, parseStates(decl.value, decl, this.diagnostics));
            }
            else {
                if (type === 'type') {
                    this.diagnostics.warn(decl, exports.processorWarnings.STATE_DEFINITION_IN_ELEMENT());
                }
                else {
                    this.diagnostics.warn(decl, exports.processorWarnings.STATE_DEFINITION_IN_COMPLEX());
                }
            }
        }
        else if (decl.prop === `-st-extends`) {
            if (isSimple) {
                const parsed = parseExtends(decl.value);
                const symbolName = parsed.types[0] && parsed.types[0].symbolName;
                const extendsRefSymbol = features_2.STSymbol.get(this.meta, symbolName);
                if ((extendsRefSymbol &&
                    (extendsRefSymbol._kind === 'import' ||
                        extendsRefSymbol._kind === 'class' ||
                        extendsRefSymbol._kind === 'element')) ||
                    decl.value === this.meta.root) {
                    this.extendTypedRule(decl, rule.selector, `-st-extends`, (0, stylable_utils_1.getAlias)(extendsRefSymbol) || extendsRefSymbol);
                }
                else {
                    this.diagnostics.warn(decl, exports.processorWarnings.CANNOT_RESOLVE_EXTEND(decl.value), { word: decl.value });
                }
            }
            else {
                this.diagnostics.warn(decl, exports.processorWarnings.CANNOT_EXTEND_IN_COMPLEX());
            }
        }
        else if (decl.prop === features_1.STMixin.MixinType.ALL || decl.prop === features_1.STMixin.MixinType.PARTIAL) {
            features_1.STMixin.hooks.analyzeDeclaration({ context: this, decl });
        }
        else if (decl.prop === `-st-global`) {
            if (isSimple && type !== 'type') {
                this.setClassGlobalMapping(decl, rule);
            }
            else {
                // TODO: diagnostics - scoped on none class
            }
        }
    }
    setClassGlobalMapping(decl, rule) {
        const name = rule.selector.replace('.', '');
        const classSymbol = features_2.CSSClass.get(this.meta, name);
        if (classSymbol) {
            const globalSelectorAst = parseGlobal(decl, this.diagnostics);
            if (globalSelectorAst) {
                classSymbol[`-st-global`] = globalSelectorAst;
            }
        }
    }
    extendTypedRule(node, selector, key, value) {
        const name = selector.replace('.', '');
        const typedRule = features_2.STSymbol.get(this.meta, name);
        if (typedRule && typedRule[key]) {
            this.diagnostics.warn(node, exports.processorWarnings.OVERRIDE_TYPED_RULE(key, name), {
                word: name,
            });
        }
        if (typedRule) {
            typedRule[key] = value;
        }
    }
}
exports.StylableProcessor = StylableProcessor;
/* @deprecated */
function validateScopingSelector(atRule, { selector: scopingSelector }, diagnostics) {
    if (!scopingSelector) {
        diagnostics.warn(atRule, features_2.STScope.diagnostics.MISSING_SCOPING_PARAM());
    }
}
exports.validateScopingSelector = validateScopingSelector;
function createEmptyMeta(root, diagnostics) {
    (0, deprecation_1.warnOnce)('createEmptyMeta is deprecated and will be removed in the next version. Use "new StylableMeta()"');
    return new stylable_meta_1.StylableMeta(root, diagnostics);
}
exports.createEmptyMeta = createEmptyMeta;
function process(root, diagnostics = new diagnostics_1.Diagnostics(), resolveNamespace) {
    return new StylableProcessor(diagnostics, resolveNamespace).process(root);
}
exports.process = process;
function prepareAST(meta, ast) {
    const toRemove = [];
    ast.walk((node) => {
        const input = { meta, node, toRemove };
        // namespace
        features_2.STNamespace.hooks.prepareAST(input);
        // custom selectors
        if (node.type === 'rule') {
            (0, stylable_utils_1.expandCustomSelectors)(node, meta.customSelectors, meta.diagnostics);
        }
        else if (node.type === 'atrule' && node.name === 'custom-selector') {
            toRemove.push(node);
        }
        // extracted features
        features_2.STImport.hooks.prepareAST(input);
        features_2.STScope.hooks.prepareAST(input);
        features_1.STVar.hooks.prepareAST(input);
        features_1.CSSCustomProperty.hooks.prepareAST(input);
    });
    for (const removeOrNode of toRemove) {
        typeof removeOrNode === 'function' ? removeOrNode() : removeOrNode.remove();
    }
}
exports.prepareAST = prepareAST;
// ToDo: remove export and reroute import from feature
exports.processNamespace = features_2.STNamespace.defaultProcessNamespace;
//# sourceMappingURL=stylable-processor.js.map